import { render, staticRenderFns } from "./header-section.vue?vue&type=template&id=2ba6f795&scoped=true"
import script from "./header-section.vue?vue&type=script&lang=js"
export * from "./header-section.vue?vue&type=script&lang=js"
import style0 from "./header-section.vue?vue&type=style&index=0&id=2ba6f795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6f795",
  null
  
)

export default component.exports